import {ready} from "./ready";
import {utils} from "./utils";
import {openPopupById} from "./popups";
import {goToByScroll} from "./go-to-by-scroll";
import Cookies from "../libs/js.cookie.min";

ready(() => {

	const breakpointMobile = window.matchMedia('(max-width: 767.98px)');

	/**
	 * Add close toggle with label to sub menus
	 */
	document.querySelectorAll('#site-navigation .menu-item-has-children').forEach(function (menuItem) {
		let menuItemLabel = menuItem.querySelector('a').textContent;
		let closeMenuItem = document.createElement('li');
		closeMenuItem.classList.add('close-sub-menu', 'menu-item');
		closeMenuItem.textContent = menuItemLabel;

		menuItem.querySelector('.sub-menu').prepend(closeMenuItem);

		closeMenuItem.addEventListener('click', function () {
			menuItem.classList.remove('open');
		});
	});


	/**
	 *  Move navigation elements on mobile
	 */

	const mainMenu      = document.getElementById('site-navigation');
	const headerButtons = document.querySelector('.site-header__buttons');

	const moveNavElementsOnMobile = function () {

		// if small viewport
		if (breakpointMobile.matches)
		{
			mainMenu.prepend(headerButtons);

		}
		// else if a larger viewport
		else
		{
			mainMenu.after(headerButtons);
		}
	};

	// keep an eye on viewport size changes
	breakpointMobile.addEventListener('change', moveNavElementsOnMobile);

	// kickstart
	moveNavElementsOnMobile();


	/**
	 * Wrap WPForms selects in <div class="select-wrapper"></div>
	 */
	document.querySelectorAll('.wpforms-form select').forEach(function (select) {
		const wrapper = document.createElement('div');
		wrapper.classList.add('select-wrapper');
		utils.wrap(select, wrapper);
	});



	/**
	 * Add the svg inside WPForms submit buttons
	 */
	document.querySelectorAll('.wpforms-submit.btn--icon-arrow').forEach(function (btn) {

		if (btn.querySelector('svg.arrow-btn-icon-white') === null)
		{
			const icon = '<svg aria-hidden="true" focusable="false" class=" arrow-btn-icon-white" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="#fff"></circle><path d="M26 15c0-.5523-.4477-1-1-1h-9c-.5523 0-1 .4477-1 1s.4477 1 1 1h8v8c0 .5523.4477 1 1 1s1-.4477 1-1zM15 25l.7071.7071 10-10L25 15l-.7071-.7071-10 10z" fill="#00a8c4"></path></svg>';

			btn.innerHTML += icon;
		}
	});


	/**
	 * Clone the svg inside buttons
	 */
	document.querySelectorAll('.btn--icon').forEach(function (btn) {
		const icon = btn.querySelector('svg');

		if (icon)
		{
			btn.prepend(icon.cloneNode(true));
		}
	});


	const pricingSwitch = document.querySelector('.pricing-switch');

	if (pricingSwitch !== null)
	{
		const pricingSwitchButtons = pricingSwitch.querySelectorAll('button');
		const prices               = document.querySelectorAll('.pricing-tier__price');
		const tooltip              = document.querySelectorAll('.pricing-tier__tooltip');
		const tierButtons          = document.querySelectorAll('.pricing-tier .btn');
		const badgeIssuances       = document.querySelectorAll('.pricing-tier__badge-issuances');

		pricingSwitchButtons.forEach(function (button) {
			button.addEventListener('click', function (e) {

				if (this.value === 'annual')
				{
					pricingSwitch.querySelector('button[value="annual"]').classList.add('btn--active');
					pricingSwitch.querySelector('button[value="monthly"]').classList.remove('btn--active');

					// show annual prices
					prices.forEach(function (el) {
						if (el.dataset.annualPrice)
						{
							el.innerHTML = el.dataset.annualPrice;
						}
					});

					// show tooltip
					tooltip.forEach(function (el) {
						el.style.opacity = '1';
					});

					// use annual values in buttons
					tierButtons.forEach(function (el) {
						el.innerHTML = el.dataset.titleAnnual;
						el.href      = el.dataset.urlAnnual;
					});

					// use annual values in issuances
					badgeIssuances.forEach(function (el) {
						el.querySelector('strong').innerHTML = el.dataset.issuancesPerYear;
					});
				}
				else
				{
					pricingSwitch.querySelector('button[value="annual"]').classList.remove('btn--active');
					pricingSwitch.querySelector('button[value="monthly"]').classList.add('btn--active');

					// show monthly prices
					prices.forEach(function (el) {
						if (el.dataset.annualPrice)
						{
							el.innerHTML = el.dataset.monthlyPrice;
						}
					});

					// hide tooltip
					tooltip.forEach(function (el) {
						el.style.opacity = '0';
					});

					// use monthly values in buttons
					tierButtons.forEach(function (el) {
						el.innerHTML = el.dataset.titleMonthly;
						el.href      = el.dataset.urlMonthly;
					});

					// use monthly values in issuances
					badgeIssuances.forEach(function (el) {
						el.querySelector('strong').innerHTML = el.dataset.issuancesPerMonth;
					});
				}
			});
		});
	}


	/**
	 * Open/close accordion for pricing tier features
	 */
	document.querySelectorAll('.toggle-features').forEach(function (el) {
		const toggle          = el;
		const panel           = el.nextElementSibling;
		panel.dataset.display = window.getComputedStyle(panel).display;

		toggle.addEventListener('click', function (e) {
			e.preventDefault();

			const transitionDuration = 600;

			// prevent from interrupting the animation
			if (toggle.classList.contains('animating'))
			{
				return;
			}
			else
			{
				toggle.classList.add('animating');
			}

			let content = panel;

			if (content !== null)
			{
				toggle.classList.toggle('active');

				if (toggle.classList.contains('active'))
				{
					toggle.textContent = toggle.dataset.activeText;
				}
				else
				{
					toggle.textContent = toggle.dataset.inactiveText;
				}

				utils.slideToggle(content, transitionDuration);

				setTimeout(() => {
					toggle.classList.remove('animating');
				}, transitionDuration);
			}
		});

		const togglePricingTierFeatures = function () {

			if (breakpointMobile.matches)
			{
				panel.style.display = 'none';
			}
			else
			{
				panel.removeAttribute('style');
				toggle.classList.remove('active');
				toggle.textContent = toggle.dataset.inactiveText;
			}
		};

		breakpointMobile.addEventListener('change', togglePricingTierFeatures);

		togglePricingTierFeatures();
	});


	/**
	 * Pricing tiers special promo
	 */
	const pricingTiers = document.querySelectorAll('.pricing-tier');

	if (pricingTiers.length > 0)
	{
		const pricingTiersCss = function () {
			let tierSpecialPromoMaxHeight = 0;
			let tierPriceBlockMaxHeight   = 0;


			if (breakpointMobile.matches)
			{
				pricingTiers.forEach(function (tier) {
					tier.style.removeProperty("padding-top");
					tier.querySelector('.pricing-tier__price-block').style.removeProperty("height");
				});
			}
			else
			{
				pricingTiers.forEach(function (tier) {
					if (tier.classList.contains('pricing-tier--special'))
					{
						let tierSpecialPromoHeight = tier.querySelector('.pricing-tier__special-promo').offsetHeight;
						if (tierSpecialPromoHeight > tierSpecialPromoMaxHeight)
						{
							tierSpecialPromoMaxHeight = tierSpecialPromoHeight;
						}
					}

					tier.querySelector('.pricing-tier__price-block').style.removeProperty("height");
					let tierPriceBlockHeight = tier.querySelector('.pricing-tier__price-block').offsetHeight;
					if (tierPriceBlockHeight > tierPriceBlockMaxHeight)
					{
						tierPriceBlockMaxHeight = tierPriceBlockHeight;
					}
				});

				pricingTiers.forEach(function (tier) {
					if (!tier.classList.contains('pricing-tier--special'))
					{
						tier.style.paddingTop                 = '20px';
						tier.closest('.col').style.paddingTop = (tierSpecialPromoMaxHeight - 20) + 'px';
					}

					tier.querySelector('.pricing-tier__price-block').style.height = tierPriceBlockMaxHeight + 'px';
				});
			}
		};

		breakpointMobile.addEventListener('change', pricingTiersCss);

		window.addEventListener('resizeHorizontallyEnd', function () {
			pricingTiersCss();
		});

		pricingTiersCss();

		equalizeHeights('.pricing-tier__description');
		equalizeHeights('.pricing-tier__price-dynamic-text');
		equalizeHeights('.pricing-tier__notes');
		equalizeHeights('.pricing-tier__highlights');
	}



	/**
	 * Set the width of the columns in the pricing comparison table
	 */
	const comparisonTable = document.querySelector('.pricing-comparison__table');

	if (comparisonTable !== null)
	{
		setTableColumnWidths(comparisonTable, {
			min:       200,
			max:       450,
			preferred: 0.30, // 25% of the table width as the "ideal" size
			otherMin:  150,
		});
	}

	/**
	 * Steps video
	 */

	const stepsVideo = document.querySelectorAll('.steps-video video');

	stepsVideo.forEach(function (video) {
		const id = video.closest('.step').dataset.id;

		video.addEventListener('ended', function () {
			Cookies.set('video-' + id + '-seen', 'true', {expires: 365})

			const nextVideoRow = document.querySelector('.step[data-id="' + (parseInt(id) + 1) + '"]');

			let offset = document.querySelector('#header').offsetHeight * -1;

			// enable next video
			if (nextVideoRow !== null)
			{
				nextVideoRow.classList.remove('disable-video');
				nextVideoRow.querySelector('video').setAttribute('controls', 'controls');

				openPopupById('popup-step-video-' + id);

				goToByScroll(nextVideoRow, offset);
			}
			// show final form
			else
			{
				const badgeForm = document.querySelector('.steps-video-form');

				badgeForm.classList.remove('steps-video-form--hidden');

				openPopupById('popup-step-video-' + id);

				goToByScroll(badgeForm, offset);
			}
		}, false);
	});


	/**
	 * Open final success message after form is submitted
	 */
	const finalVideoForm = document.getElementById('wpforms-10412');

	if (finalVideoForm !== null)
	{
		finalVideoForm.addEventListener('wpformsAjaxSubmitSuccess', function (e, response) {
			openPopupById('popup-badge-issued');
			Cookies.set('badge-already-issued', 'true', {expires: 365});
		});
	}

	/**
	 * Add bootstrap classes to .wpforms-field-container
	 */
	document.querySelectorAll('.wpforms-field-container').forEach(function (el) {
		el.classList.add('row', 'gx-2', 'row-gap-2');
	});


	/**
	 * Manage global popup
	 * @type {Element}
	 */
	const globalPopup = document.querySelector('.global-popup');

	if (globalPopup !== null)
	{
		let globalPopupAlreadyOpened = sessionStorage.getItem("globalPopupAlreadyOpened");

		if (globalPopupAlreadyOpened !== '1')
		{
			const openAfter = globalPopup.dataset.openAfter;

			setTimeout(function () {
				globalPopup.classList.add('global-popup--active');
				sessionStorage.setItem("globalPopupAlreadyOpened", '1');
			}, openAfter);

			globalPopup.querySelector('.global-popup__close').addEventListener('click', function () {
				globalPopup.classList.remove('global-popup--active');
			});
		}
	}


	/**
	 * Manage fixed banner
	 * @type {Element}
	 */
	const fixedBanner = document.querySelector('.fixed-banner');

	if (fixedBanner !== null)
	{
		window.addEventListener('scroll', function () {
			let fixedBannerAlreadyOpened = sessionStorage.getItem("fixedBannerAlreadyOpened");

			if (fixedBannerAlreadyOpened !== '1')
			{
				let scrollDistance    = 700;
				let documentScrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;

				if (documentScrollTop > scrollDistance && document.querySelector('.global-popup--active') === null)
				{
					fixedBanner.classList.add('fixed-banner--active');
				}
				else
				{
					fixedBanner.classList.remove('fixed-banner--active');
				}
			}
		});

		fixedBanner.querySelector('.fixed-banner__close').addEventListener('click', function () {
			sessionStorage.setItem("fixedBannerAlreadyOpened", '1');
			fixedBanner.classList.remove('fixed-banner--active');
		});
	}


	/**
	 * Toggle chat window when clicking on an element with "open-chat" class
	 */
	document.querySelectorAll('.open-chat').forEach(function (el) {
		el.addEventListener('click', function () {
			const chatToggle = document.querySelector('.chat-window-toggle');
			chatToggle?.click();
		});
	});


	/**
	 * Play videos
	 * @type {NodeListOf<Element>}
	 */
	const playBtns = document.querySelectorAll('span.play');

	playBtns.forEach(function (el) {
		const section = el.closest('div');
		const video   = section.querySelector('video');
		//const seekBar = el.nextElementSibling;

		el.addEventListener('click', function () {
			video.play();
			video.setAttribute('controls', 'true');
			section.classList.add('playing');
		});

		video.addEventListener('pause', function () {
			if (video.readyState !== 4)
			{
				return true;
			}

			// Firefox dispatches the pause event but
			// doesn't set the video to paused
			setTimeout(() => {
				if (video.paused)
				{
					section.classList.remove('playing');
					video.removeAttribute('controls');
				}
			}, 150);
		});

		video.addEventListener('ended', function () {
			section.classList.remove('playing');
			video.removeAttribute('controls');
			video.currentTime = 0; // reset video
		});

		/*video.addEventListener('timeupdate', function () {
			const percentage    = (video.currentTime / video.duration) * 100;
			seekBar.style.width = percentage + '%';
		});*/
	});


	/**
	 * Equalizes the height of a group of elements to the tallest one.
	 * Resets on mobile. Re-runs on the custom `resizeEnd` event.
	 *
	 * @param {NodeList|HTMLElement[]|string} els - Elements, NodeList, or CSS selector.
	 * @param {number} [breakpoint=768] - Below this width heights are reset.
	 */
	function equalizeHeights(els, breakpoint = 768) {
		if (typeof els === 'string')
		{
			els = document.querySelectorAll(els);
		}

		const items = Array.from(els);

		if (!items.length)
		{
			return;
		}

		const apply = () => {
			// Always reset first to get natural heights
			items.forEach(el => (el.style.height = ''));

			if (window.innerWidth < breakpoint)
			{
				return;
			}

			const max = Math.max(...items.map(el => el.getBoundingClientRect().height));
			items.forEach(el => (el.style.height = `${max}px`));
		};

		apply();
		window.addEventListener('resizeEnd', apply);
	}


	/**
	 * Clamps the first column of a table between a min and max pixel width,
	 * distributing the remaining space equally across all other columns.
	 * When a breakpoint is provided, the clamp is applied only when the query does not match.
	 *
	 * @param {HTMLTableElement} table
	 * @param {object}           options
	 * @param {number}           options.min          - First column minimum width (px)
	 * @param {number}           options.max          - First column maximum width (px)
	 * @param {number}           [options.preferred]  - Ideal first column width as a fraction of the table width (default: 0.2)
	 * @param {number}           [options.otherMin]   - Minimum width for all columns after the first (px)
	 * @param {MediaQueryList}   [breakpoint]         - Optional breakpoint; clamp is removed when the query matches
	 */
	function setTableColumnWidths(table, {min, max, preferred = 0.2, otherMin = 0}, breakpoint = null) {
		const columnCount = table.querySelector('tr')?.cells.length ?? 0;
		if (columnCount < 2)
		{
			return;
		}

		// Ensure a <colgroup> with the correct number of <col> elements exists.
		// Col elements are the most reliable way to set column widths in fixed table layout.
		let colgroup = table.querySelector('colgroup');

		if (!colgroup)
		{
			colgroup = document.createElement('colgroup');
			table.prepend(colgroup);
		}

		while (colgroup.children.length < columnCount) colgroup.appendChild(document.createElement('col'));
		while (colgroup.children.length > columnCount) colgroup.lastElementChild.remove();

		const columnEls = [...colgroup.children];
		let observer    = null;

		function setColumnWidths([entry]) {
			const tableWidth = entry.contentRect.width;

			// Clamp the first column's ideal fractional width between its min and max
			const firstColumnWidth = Math.min(Math.max(min, tableWidth * preferred), max);

			// Distribute the remaining space equally across all other columns,
			// respecting the optional minimum. If otherMin pushes the total beyond
			// the table width, the table will overflow — this is intentional.
			const sharedColumnWidth = Math.max(otherMin, (tableWidth - firstColumnWidth) / (columnCount - 1));

			columnEls[0].style.width = `${firstColumnWidth}px`;

			for (let i = 1; i < columnEls.length - 1; i++)
			{
				columnEls[i].style.width = `${sharedColumnWidth}px`;
			}

			// Leave the last column without an explicit width so the browser fills the
			// true remainder, avoiding border clipping from subpixel rounding.
			// Only force a width if the natural remainder would fall below otherMin.
			const naturalLastColumnWidth                = tableWidth - firstColumnWidth - sharedColumnWidth * (columnCount - 2);
			columnEls[columnEls.length - 1].style.width = naturalLastColumnWidth < otherMin ? `${otherMin}px` : '';
		}

		function applyClamp() {
			table.style.tableLayout = 'fixed';
			observer                = new ResizeObserver(setColumnWidths);
			observer.observe(table.parentElement);
		}

		if (breakpoint)
		{
			// removeClamp is only relevant when a breakpoint is involved
			function removeClamp() {
				observer?.disconnect();
				observer = null;
				columnEls.forEach(col => col.style.width = '');
				table.style.tableLayout = '';
			}

			function onBreakpointChange({matches}) {
				matches ? removeClamp() : applyClamp();
			}

			breakpoint.addEventListener('change', onBreakpointChange);
			onBreakpointChange(breakpoint); // evaluate immediately with the current state
		}
		else
		{
			applyClamp();
		}
	}

}); // END ready


/**
 * ON LOAD
 */

window.addEventListener('load', function (event) {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});



/**
 * ON RESIZE
 */
window.addEventListener('resize', function (event) {

});


/**
 * ON RESIZE END
 */

// do something when the window resizing ends
window.addEventListener('resizeEnd', function () {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});

window.addEventListener('resizeHorizontallyEnd', function () {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});


/**
 * ON SCROLL
 */
/*window.addEventListener('scroll', function() {
});*/